import React from "react";
import { useState } from "react";
const ClientTalkCard = ({ title, designation, desc, src }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 670);

  return (
    <div className="swiper-slide" style={{width : isMobile && 320, }}>
      <div className="testimonial-item-three" >
        <div className="testimonial-thumb-three">
          <img 
            src={src} 
            alt={title} 
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/img/images/testimonial_avatar01.png"; // Fallback image
            }}
          />
        </div>

        <div className="testimonial-content-three">
          <h4 className="title" style={{marginTop : 10}}>{title}</h4>
          <span style={{marginTop : 0}}>{designation}</span>
          <p className="testimonial-text" >"{desc}"</p>
        </div>
      </div>
    </div>
  );
};

export default ClientTalkCard;